module.exports = __webpack_public_path__ + "static/media/compona-logo.a7d25863.svg";